<template>
  <div class="layoutt">
    <!-- <el-menu :show-timeout="200" :default-active="$route.path" :collapse="isCollapse" mode="horizontal"
      background-color="#438EB9" text-color="#bfcbd9" active-text-color="#fff" class="el-menu-demo">
      <SidebarItem v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
    </el-menu> menu-trigger="click"-->
    <el-menu :default-active="$route.path" :collapse="isCollapse" mode="horizontal" background-color="rgba(0,0,0,0)"
      class="el-menu-demo" text-color="#064FBD" active-text-color="#064FBD" menu-trigger="click">
      <SidebarItem v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem.vue";
export default {
  name: "layoutt",
  components: {
    SidebarItem,
  },
  data() {
    return {
      activeIndex2: "1",
      isweb: true,
    };
  },
  computed: {
    ...mapGetters(["permission_routes", "sidebar"]),
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  created() { },
  mounted() {
    // this.getList()
    //浏览器放大缩小事件
this.$nextTick(() => {
            this.resizeFun();
            // this.resizeFun窗口变化执行的方法
            window.addEventListener("resize", this.resizeFun);
            let screenWidth = document.body.clientWidth;
            let screenHeight = document.body.clientHeight;
            if (screenWidth < 1100) {
                this.isweb = false
            } else {
                this.isweb = true
            }
        });
  },
  methods: {
    resizeFun() {
            // 窗口变化执行的操作
            var screenWidth = window.innerWidth;
            if (screenWidth < 1100) {
                this.isweb = false
            } else {
                this.isweb = true
            }
        },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.layoutt {
  width: 54%;
  height: 40px;
}

.layoutt .el-menu {
  width: 100%;
  height: 40px;
  margin-top: 10px;
  border-right: 0;
}


.el-menu--horizontal {
  border-bottom: 0px !important;
}
@media (max-width:500px){
 .layoutt{
  width: 100%;
  border-bottom: 2px solid #0061AE;
 } 
}
</style>
